import MoreHorizRounded from '@mui/icons-material/MoreHorizRounded';
import PendingActionsOutlined from '@mui/icons-material/PendingActionsOutlined';
import PsychologyOutlined from '@mui/icons-material/PsychologyOutlined';
import SearchRounded from '@mui/icons-material/SearchRounded';
import { TreadAgentToolCallActivityKind } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

// Keyed by the enum so a value added to the spec fails the build here, but looked up defensively
// at runtime: activity_kind comes off the socket, and a version skew in either direction must not
// throw inside render and take the page down with it.
const ACTIVITY_KIND_PRESENTATION: Record<
  TreadAgentToolCallActivityKind,
  { Icon: typeof SearchRounded; labelKey: string }
> = {
  [TreadAgentToolCallActivityKind.DISCOVERY]: {
    Icon: SearchRounded,
    labelKey: 'tread_agent.trace.kind_label.discovery',
  },
  [TreadAgentToolCallActivityKind.READ]: {
    Icon: SearchRounded,
    labelKey: 'tread_agent.trace.kind_label.read',
  },
  [TreadAgentToolCallActivityKind.WRITE_PROPOSAL]: {
    Icon: PendingActionsOutlined,
    labelKey: 'tread_agent.trace.kind_label.write_proposal',
  },
};

const UNSPECIFIED_PRESENTATION = {
  Icon: MoreHorizRounded,
  labelKey: 'tread_agent.trace.kind_label.unspecified',
};

export const REASONING_ICON = PsychologyOutlined;

export default function activityKindPresentation(
  activityKind: TreadAgentToolCallActivityKind | null,
) {
  const presentation =
    (activityKind && ACTIVITY_KIND_PRESENTATION[activityKind]) ??
    UNSPECIFIED_PRESENTATION;

  return { Icon: presentation.Icon, label: t(presentation.labelKey) };
}
